import { render } from "./ProductCardItem.vue?vue&type=template&id=fc4829ac&scoped=true"
import script from "./ProductCardItem.vue?vue&type=script&lang=js"
export * from "./ProductCardItem.vue?vue&type=script&lang=js"

import "./ProductCardItem.vue?vue&type=style&index=0&id=fc4829ac&lang=scss&scoped=true"
import "./ProductCardItem.vue?vue&type=style&index=1&id=fc4829ac&lang=scss"

import exportComponent from "../../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fc4829ac"]])

export default __exports__